import { FruitType } from "../../context";

export const folderText = [
	`Выбирайте, с кого начать: манго, молока или роллов с форелью. Когда устроите на полку первых кандидатов — с нас промокод со скидкой. А если проверите все продукты — получите самый вкусный промокод`,
	`Рады видеть вас снова. Устройте на полку оставшихся кандидатов и получите второй промокод. Кого проверим в этот раз?`,
	`Ещё раз привет! Осталось проверить последнего кандидата и забрать второй промокод. Приступим?`,
	`И снова здравствуйте! Вы проверили всех кандидатов и забрали оба промокода — теперь можете поиграть просто в удовольствие`,
];

export const boldWords = [
	"с нас промокод со скидкой",
	"самый вкусный промокод",
	"второй промокод",
];

interface Character {
	name: string;
	type: FruitType;
}

export const characters: Character[] = [
	{ name: "мОлоКО", type: "milk" },
	{ name: "мангО", type: "mango" },
	{ name: "рОлЛ", type: "roll" },
];

export const onboardSteps = [
	"Строго отбираем производителей и поставщиков: анализируем их историю, проверяем документы, изучаем систему контроля качества",
	"Детально проверяем чистоту состава не только по российским нормам, но и по европейским — так учитываем гораздо больше параметров",
	"Проводим около 480 аудитов поставщиков в год — для этого у нас есть собственные специалисты",
	"Запустили онлайн-аудиты «ВЖИК». С 2020 года они позволяют быстрее проводить проверки",
	`Не допускаем в магазины продукты с консервантами за редким исключением, когда они нужны для обеспечения безопасности, например, в рыбной гастрономи`,
	`Оперативно реагируем на сообщения покупателей — обрабатываем 1 000 000 обращений месяц. Они помогают доработать продукты или изъять некачественный товар с полок всего за несколько часов`,
];
